// Build60's first-review-per-album rule with the approved ten-row web page windows.
// Raw review totals cannot be used as unique-album totals.
export async function loadReviewWindow(args, signal, load, seed) {
  const size = args.size;
  let pages = seed?.pages ? [...seed.pages] : [];
  let complete = seed?.complete || false;
  const select = () => {
    const seen = new Set();
    return pages
      .flatMap((page) => page.albums)
      .filter((item) => {
        if (!item?.content?.trim()) return false;
        const id = args.view === 'albums' ? item.albumId : item.reviewId;
        if (id == null || seen.has(String(id))) return false;
        seen.add(String(id));
        return true;
      });
  };
  let items = select();
  const needed = args.page * size;
  // One extra unique item establishes whether another display page really exists.
  while (!complete && items.length <= needed) {
    if (signal?.aborted) throw new DOMException('Aborted', 'AbortError');
    const page = pages.length + 1;
    const result = await load('reviews', { ...args, page }, signal);
    if (signal?.aborted) throw new DOMException('Aborted', 'AbortError');
    if (Number(result.pagination?.currentPage) !== page) throw new Error('Unexpected review page');
    const totalPages = Number(result.pagination?.totalPages);
    if (!Number.isSafeInteger(totalPages) || totalPages < 0)
      throw new Error('Invalid review pagination');
    pages.push(result);
    complete = page >= totalPages;
    items = select();
  }
  const totalPages = Math.max(1, Math.ceil(items.length / size));
  const currentPage = Math.min(args.page, totalPages);
  return {
    albums: items.slice((currentPage - 1) * size, currentPage * size),
    pagination: { currentPage, totalPages, totalItems: complete ? items.length : null },
    source: { pages, complete },
  };
}
export function reviewColumns(view, tablet, desktop) {
  return view === 'feed' ? (tablet ? 2 : 1) : desktop ? 5 : tablet ? 4 : 2;
}
export function albumCategoryParams(filters, category, saved = {}) {
  return {
    ...filters,
    category,
    region: saved.region || 'all',
    sort: saved.sort || (category === 'recommended' ? 'latest' : 'recommended'),
    page: saved.page || 1,
  };
}
